import React from "react";
import styles from "./ArrayStepper.module.css";

const ArrayStepper = ({ trackingStatus }) => {
  const steps = trackingStatus;

  return (
    <div className={styles.stepperWrapper}>
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <div className={styles.stepItem}>
            <div className={styles.stepCircle}>{index + 1}</div>
            <div className={styles.stepLabel}>{step}</div>
          </div>

          {index < steps.length - 1 && <div className={styles.stepLine} />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ArrayStepper;
